import {
  faLightbulb,
  faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import {
  Card,
  Row,
  Col,
  ProgressBar,
  Badge,
  Button,
  Modal,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getQRFunnelRecommendations } from "../../../redux/slices/MonthlyReportSlice";

const QRFunnelSummary = ({ qrOverview }) => {
  const [showModal, setShowModal] = useState(false);
  const {
    recomendationsLoading: loading,
    recommendationsError: error,
    recommendations,
  } = useSelector((state) => state.monthlyReports);

  const q = qrOverview || {};

  const dispatch = useDispatch();

  const scans = q.totalScans ?? 0;
  const intents = q.totalTipIntents ?? 0;
  const success = q.totalSuccessfulTips ?? 0;

  const pctNum = (v) => Math.round((Number(v) || 0) * 100);
  const pct = (v) => `${pctNum(v)}%`;

  const scanToIntent = q.scanToTipIntentConversion || 0;
  const intentToSuccess = q.tipIntentToSuccessConversion || 0;
  const scanToSuccess = q.scanToSuccessConversion || 0;
  const handleCreateRecomendations = () => {
    setShowModal(true);
    dispatch(getQRFunnelRecommendations(qrOverview));
  };

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>AI Recommendations</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div
            style={{
              minHeight: 280,
              maxHeight: "60vh",
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              justifyContent: loading ? "center" : "flex-start",
            }}
          >
            {loading ? (
              <div className="text-center py-4">
                {/* <Spinner animation="border" /> */}
                <div className="small text-muted mt-2">
                  Analyzing your QR funnel…
                </div>
              </div>
            ) : (
              <>
                <div style={{ whiteSpace: "pre-wrap" }}>{recommendations}</div>
                <div
                  className="d-flex align-items-center justify-content-center small text-muted mt-3"
                  style={{ fontSize: "11px" }}
                >
                  <FontAwesomeIcon icon={faQuestionCircle} className="me-2" />
                  AI can make mistakes. Please verify important information.
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <Card className="h-100 shadow-sm rounded-3" style={{ minHeight: 260 }}>
        <Card.Body>
          {/* <div className="d-flex justify-content-between align-items-center mb-3"> */}
          <Card.Title className="mb-4">
            <div className="d-flex justify-content-between align-items-center">
              <span>QR Code Conversions</span>
              <Button
                variant="outline-warning"
                size="sm"
                className=" rounded-circle"
                title="Get Recomendations"
                onClick={handleCreateRecomendations}
              >
                <FontAwesomeIcon icon={faLightbulb} />
              </Button>
            </div>
          </Card.Title>

          {/* <div className="text-end">
            <div className="small text-muted mb-1">Overall Scan → Success</div>
            <Badge bg="success" pill style={{ fontSize: "0.75rem" }}>
              {pct(scanToSuccess)}
            </Badge>
          </div> */}
          {/* </div> */}

          <div className="mb-4">
            <div className="d-flex justify-content-between small mb-1">
              <span>Scan → Success</span>
              <span className="fw-semibold">{pct(scanToSuccess)}</span>
            </div>
            <div className="small text-muted mb-1">
              {success} successful tips from {scans || 1} scans
            </div>
            <ProgressBar
              now={pctNum(scanToSuccess)}
              variant="success"
              style={{ height: 10, borderRadius: 999 }}
            />
          </div>

          {/* Top stats row */}
          <Row className="g-2 mb-3">
            <Col xs={4}>
              <div className="p-2 rounded-3" style={{ background: "#f3f4f6" }}>
                <div className="small text-muted">QR Code scans</div>
                <div className="fw-semibold fs-6">{scans}</div>
              </div>
            </Col>
            <Col xs={4}>
              <div className="p-2 rounded-3" style={{ background: "#f3f4f6" }}>
                <div className="small text-muted">Tips entered</div>
                <div className="fw-semibold fs-6">{intents}</div>
              </div>
            </Col>
            <Col xs={4}>
              <div className="p-2 rounded-3" style={{ background: "#f3f4f6" }}>
                <div className="small text-muted">Tips completed</div>
                <div className="fw-semibold fs-6">{success}</div>
              </div>
            </Col>
          </Row>

          {/* Funnel steps */}
          <div className="mb-3">
            <div className="d-flex justify-content-between small mb-1">
              <span>Scan → Tips entered</span>
              <span className="fw-semibold">{pct(scanToIntent)}</span>
            </div>
            <div className="small text-muted mb-1">
              {intents} of {scans || 1} scans led to a tip being entered
            </div>
            <ProgressBar
              now={pctNum(scanToIntent)}
              style={{ height: 10, borderRadius: 999 }}
            />
          </div>

          <div className="mb-3">
            <div className="d-flex justify-content-between small mb-1">
              <span>Tips entered → Success</span>
              <span className="fw-semibold">{pct(intentToSuccess)}</span>
            </div>
            <div className="small text-muted mb-1">
              {success} of {intents || 1} entered tips were completed
            </div>
            <ProgressBar
              now={pctNum(intentToSuccess)}
              variant="info"
              style={{ height: 10, borderRadius: 999 }}
            />
          </div>

          {/* <div>
          <div className="d-flex justify-content-between small mb-1">
            <span>Scan → Success</span>
            <span className="fw-semibold">{pct(scanToSuccess)}</span>
          </div>
          <div className="small text-muted mb-1">
            {success} successful tips from {scans || 1} scans
          </div>
          <ProgressBar
            now={pctNum(scanToSuccess)}
            variant="success"
            style={{ height: 10, borderRadius: 999 }}
          />
        </div> */}
        </Card.Body>
      </Card>
    </>
  );
};

export default QRFunnelSummary;
